import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import ViewReport from "./ViewReport";
import DeleteReport from "./DeleteReport";
import ExportCSVReport from "../../../../components/ExportCSVReport";
import { titleCase, upperCase } from "../../../../config/Global";

interface DataType {
  index: number;
  row_id: number;
  type: string;
  report_date: string;
  report_year: string;
  response: string;
  provider_code: string;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
  } = props;

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleDeleteRequestClose = (record: any) => {
    setOpenDeleteModal(false);
    setOpenDeleteData({});
  };

  const columns: ColumnsType<DataType> = [
    // {
    //   title: "ID",
    //   dataIndex: "index",
    //   key: "index",
    //   width: 120,
    //   sortDirections: ["descend", "ascend"],
    //   sorter: (a, b) => a.index - b.index,
    //   render: (_, record) => {
    //     return record.index;
    //   },
    // },
    {
      title: "Type",
      key: "type",
      dataIndex: "type",
      width: 200,
      className: "reportType",
      fixed: "left",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.type.localeCompare(b.type),
      render: (_, record) => {
        return record?.type && titleCase(record?.type);
      },
    },
    {
      title: "To Provider",
      key: "provider_code",
      dataIndex: "provider_code",
      width: 200,
      fixed: "left",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.provider_code.localeCompare(b.provider_code),
      render: (_, record) => {
        return record?.provider_code && upperCase(record?.provider_code);
      },
    },
    {
      title: "Report For",
      children: [
        {
          title: "Report Date",
          dataIndex: "report_date",
          key: "report_date",
          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.report_date || "").localeCompare(b.report_date || ""),
          render: (_, record) => {
            return record.report_date ?? '-';
          },
        },
        {
          title: "Report Year",
          dataIndex: "report_year",
          key: "report_year",
          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.report_year || "").localeCompare(b.report_year || ""),
          render: (_, record) => {
            return record.report_year ?? '-';
          },
        },
      ],
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : '-';
      },
    },
    {
      title: "Action",
      key: "action",
      width: 200,
      // fixed: 'right',
      render: (_, record) => {
        const viewData = record?.response ? JSON.parse(record?.response) : null;
        return (
          <Space size="middle">
            <Tooltip title={"View Report"}>
              <Button
                type="default"
                icon={<EyeOutlined />}
                className="EditBtn iconBtn"
                onClick={() => handleViewReport(record)}
              />
            </Tooltip>
            <Tooltip title={"Export Report"}>
              {viewData && <ExportCSVReport elements={viewData} reportName={`publish-${record.type}-${Date.now()}`} label={false}/>}
            </Tooltip>
            <Tooltip title={"Delete Report"}>
              <Button
                onClick={() => {
                  handleDeleteRequest(record);
                }}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
            {/* <Tooltip title={'Delete Report'}>
              <Button
                type='default'
                icon={<DeleteOutlined />}
                className='cancelBtn'
                onClick={() => handleDeleteRequest(record)}>
                Delete
              </Button>
            </Tooltip> */}
          </Space>
        );
      },
    },
  ];

  const providersData: DataType[] = listData?.map((item, index) => ({
    key: index.toString(),
    index: item.index,
    id: item._id,
    row_id: item._id,
    type: item?.type,
    report_date: item?.report_date,
    report_year: item?.report_year,
    response: item?.response,
    provider_code: item?.provider_code,
    created_date: item?.created_date,
  }));

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const handleViewReport = (data: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(data);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={providersData}
          columns={columns}
          pagination={false}
          loading={tableloading}
        />
        <div className="text-center mt-20 mb-30 providerTable">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.current}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size}
            // showSizeChanger={totalData ? true : false}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>

      {openUpdateModal && (
        <ViewReport
          openUpdateModal={openUpdateModal}
          openUpdateData={openUpdateData}
          handleViewReport={handleViewReport}
        />
      )}

      <DeleteReport
        // title={openDeleteData?.id}
        title={"Report"}
        close={handleDeleteRequestClose}
        open={openDeleteModal}
        deleteValues={openDeleteData?.row_id}
        getList={getList}
      />
    </>
  );
};
export default ListTable;
